module.exports = __webpack_public_path__ + "img/logo.87d2a488.png";